import { DamageRptService } from '../services/DamageRptService';
import { DamageRptConstants } from '../constants/DamageRptConstants';
import {alertActions} from '.';

export const DamageRptActions = {
    getAll,
    loadingData,
    exportData
};

function getAll(obj)
{
    return dispatch =>{
        dispatch(request());

        DamageRptService.fetchDamageData(obj).then(response => {
            dispatch(loadingData(false));
            dispatch(success(response.ResponseData))


            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) { delete v.TotalRows; delete v.CreatedBy; 
                    delete v.DocURL; delete v.DamageId; delete v.ProductID
                });
            }            
            dispatch(successExport(data))
        },
        error => {
            dispatch(failure(error.toString()));
            dispatch(alertActions.error(error.toString()));
        }
        
        );
    };
    function request() { return { type : DamageRptConstants.GETALL_REQUEST } }
    function success(datas) { return { type: DamageRptConstants.GETALL_SUCCESS, datas } }
    function successExport(datas) { return { type: DamageRptConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type: DamageRptConstants.GETALL_FAILURE, error } }
}

function exportData(obj) {
    return dispatch => {
        dispatch(request());
        DamageRptService.fetchDamageData(obj).then(response => {
            dispatch(loadingData(false));
            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) { delete v.TotalRows; delete v.CreatedBy; 
                    delete v.DocURL; delete v.DamageId; delete v.ProductID
                });
            }
            dispatch(success(data))
        },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            });
    };
    function request() { return { type: DamageRptConstants.GETEXPORT_REQUEST } }
    function success(datas) { return { type: DamageRptConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type: DamageRptConstants.GETEXPORT_FAILURE, error } }
}

function loadingData(isbool) {
    return {
        type: DamageRptConstants.LOADING_REQUEST, isbool
    }
}

